/** The collapsible guide and list styles shared by the Settings › Help guides. */

export const listStyle: React.CSSProperties = { margin: "8px 0 0", paddingLeft: 18, lineHeight: 1.6 };
export const subList: React.CSSProperties = { margin: "4px 0", paddingLeft: 18 };

export function Guide({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <details style={{ fontSize: 12.5, color: "var(--muted)", padding: "12px 0", borderTop: "1px solid var(--tint2)" }}>
      <summary style={{ cursor: "pointer", color: "var(--ink2)", fontSize: 13.5, fontWeight: 500 }}>{title}</summary>
      {children}
    </details>
  );
}
